<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Folgas</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <base-button
                  type="info"
                  class="animation-on-hover"
                  @click="voltarF()"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar funcionário"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>

            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Lançar Folga"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="adicionarFolgaF(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-add"></i>
                    </base-button>
                  </el-tooltip>
                  <modal :show.sync="addFolga">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Adiconar Folga
                      </h4>
                    </template>
                    <div class="text-left">
                      <h5 class="text-left">
                        <strong>Funcionário:</strong>
                        {{ funcionarioSelecionado.nome }}
                      </h5>
                      <div
                        class="row d-flex flex-row text-left justify-content-start"
                      >
                        <base-input
                          label="De"
                          class="col-6"
                          type="date"
                          v-model="dataF.de"
                        >
                        </base-input>
                        <base-input
                          label="Até"
                          class="col-6"
                          type="date"
                          v-model="dataF.ate"
                        >
                        </base-input>
                      </div>
                    </div>
                    <template slot="footer">
                      <base-button type="danger" @click="addFolga = false"
                        >Fechar</base-button
                      >
                      <base-button type="success">Salvar</base-button>
                    </template>
                  </modal>

                  <el-tooltip
                    content="Visualizar Folga"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click="visualizarFolgaF(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-attach-87"></i>
                    </base-button>
                  </el-tooltip>
                  <!-- aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa -->
                  <modal :show.sync="visualizarFolga">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">Folgas</h4>
                    </template>
                    <div>
                      <h5 class="text-left">
                        <strong>Funcionário:</strong>
                        {{ funcionarioSelecionado.nome }}
                      </h5>
                      <div
                        class="container scroll"
                        style="overflow-y: auto; max-height: 300px;"
                      >
                        <div class="row">
                          <div class="col-10 text-left">
                            Criado em
                          </div>
                          <div class="col-2"></div>
                        </div>
                        <div
                          class="row"
                          v-for="item in todasFolgas"
                          :key="item.id"
                        >
                          <div class="col-9 text-left">
                            <!-- De 23/12/2021 Até 23/12/2021 -->
                            {{ item.dt_criacao }}
                          </div>
                          <div
                            class="col-3 d-flex flex-row justify-content-end"
                          >
                            <el-tooltip
                              content="Editar"
                              effect="light"
                              :open-delay="300"
                              placement="top"
                            >
                              <base-button
                                @click="handleEdit(item)"
                                class="edit btn-link"
                                type="info"
                                size="sm"
                                icon
                              >
                                <i class="tim-icons icon-pencil"></i>
                              </base-button>
                            </el-tooltip>

                            <el-tooltip
                              content="Excluir"
                              effect="light"
                              :open-delay="300"
                              placement="top"
                            >
                              <base-button
                                @click="handleDelete(item.id)"
                                class="remove btn-link"
                                type="danger"
                                size="sm"
                                icon
                              >
                                <i class="tim-icons icon-simple-remove"></i>
                              </base-button>
                            </el-tooltip>
                          </div>
                        </div>
                        <!-- <div class="row">
                                <div class="col-10 text-left">
                                    De 23/12/2021 Até 23/12/2021
                                </div>
                                <div class="col-2">
                                    <el-tooltip content="Excluir" effect="light" :open-delay="300" placement="top">
                                        <base-button
                                        @click.native="handleDelete(props.$index, props.row)"
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                        >
                                        <i class="tim-icons icon-simple-remove"></i>
                                        </base-button>
                                    </el-tooltip>
                                </div>
                            </div> -->
                      </div>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="visualizarFolga = false"
                        >Fechar</base-button
                      >
                    </template>
                  </modal>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} funcionários.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../../../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../../Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import jwt from "jsonwebtoken";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  props: {
    dadosFuncionarios: {
      type: Object,
      default: {},
    },
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      addFolga: false,
      visualizarFolga: false,
      dataF: {
        de: "",
        ate: "",
      },
      listFolgas: [],
      todasFolgas: [],

      funcionarioSelecionado: {},
      horarioSelecionado: "",
      dialogDemitirFuncionario: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      demitir: {
        data: "",
        motivo: "",
      },
      isLoading: false,
      searchQuery: "",
      propsToSearch: ["nome"],
      tableColumns: [
        {
          prop: "nome",
          label: "Nome",
          minWidth: 200,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.tableData = this.dadosFuncionarios;
    // this.notifyVue('top', 'center');
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["nome"],
      threshold: 0.3,
    });
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    handleEdit(row) {
      let w1 = jwt.sign(
        { data: { idFolga: row.id, idFuncionario: row.id_empregados } },
        "qXTflPwOaD",
        {
          expiresIn: "1h",
        },
      );
      this.$router.push(`/editarFolga/${w1}`);
    },

    adicionarFolgaF(index, row) {
      let w1 = jwt.sign({ data: { idFuncionario: row.id } }, "qXTflPwOaD", {
        expiresIn: "1h",
      });
      this.$router.push(`/lancarFolga/${w1}`);
    },

    visualizarFolgaF(index, row) {
      this.listarFolgas(row.id);
      this.visualizarFolga = true;
      this.funcionarioSelecionado = row;
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    listarFolgas(idFuncionario) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregados: idFuncionario,
      };
      this.axios
        .post("/api/folga/listarTodasFolga", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.todasFolgas = response.data.data.dados;
        })
        .catch((err) => {
          th.isLoading = false;
        });
    },

    handleDelete(idFolga) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: idFolga,
      };
      this.axios
        .post("/api/folga/deletarFolga", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Folga deletada com sucesso!",
            "success",
          );
          th.listarFolgas(th.funcionarioSelecionado.id);
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao deletar folga!", "error");
        });
    },

    voltarF() {
      this.$root.$emit("voltarPesquisarEscalaDepartamento", 1);
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}

::-webkit-scrollbar {
  width: 12px;
  /* width of the entire scrollbar */
}

::-webkit-scrollbar-track {
  background: #e7e7e7;
  /* color of the tracking area */
  border-radius: 0px;
}

::-webkit-scrollbar-thumb {
  background-color: #929292;
  /* color of the scroll thumb */
  border-radius: 0px;
  /* roundness of the scroll thumb */
  border: 2px solid #e7e7e7;
  /* creates padding around scroll thumb */
}
</style>
